/**
 * Reine Hilfen für den Reiter „Spaltenzuordnungen“. Der Server speichert Feld → Spalte; die Oberfläche
 * zeigt Spalte → Feld, weil man die Kopfzeile entlang liest. Pflichtfelder wie auf dem Server
 * (tri-server src/invoicing/tables/columnMapping.ts, `missingRequired`).
 */

export const NONE = "__none__";

/** Spalte → Feld, aus der gespeicherten Zuordnung Feld → Spalte. */
export const fieldByColumn = (columns: Record<string, string>): Record<string, string> =>
  Object.fromEntries(Object.entries(columns).map(([field, column]) => [column, field]));

/** Feld → Spalte, aus der Auswahl je Spalte; „keins“ fällt heraus. */
export const columnsFromSelection = (selection: Record<string, string>): Record<string, string> =>
  Object.fromEntries(
    Object.entries(selection)
      .filter(([, field]) => field && field !== NONE)
      .map(([column, field]) => [field, column]),
  );

/** Ein Feld, das zwei Spalten bekommen haben — der Server lehnt das ab, die Oberfläche sagt es vorher. */
export const doubledFields = (selection: Record<string, string>): string[] => {
  const seen = new Map<string, number>();
  for (const field of Object.values(selection)) if (field && field !== NONE) seen.set(field, (seen.get(field) ?? 0) + 1);
  return Array.from(seen.entries()).filter(([, n]) => n > 1).map(([f]) => f);
};

/** Was zum Lesen fehlt: welche Rechnung, von wem, wie viel. */
export const missingRequired = (columns: Record<string, string>): string[] => {
  const missing: string[] = [];
  if (!columns.number) missing.push("number");
  if (!columns.supplierNumber && !columns.supplierName) missing.push("supplier");
  if (!columns.grossAmount && !columns.netAmount && !columns.lineNetAmount) missing.push("amount");
  return missing;
};
